import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FeaturesSection />
        <ContactSection />
        <AppSection />
        <CardsSection />
        <IndexSection />
        <CarouselSection />
        <TopicsSection />
        <RankingSection />
        <FaqSection />
        <CommentsSection />
        <AboutSection />
        <MediaSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}